var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "BUENOS AIRES": {
    "20 DE JUNIO": {
      "1786": true
    },
    "9 DE ABRIL": {
      "1839": true
    },
    "ACASSUSO": {
      "1641": true
    },
    "ALDO BONZI": {
      "1771": true
    },
    "ALEJANDRO PETION": {
      "1811": true
    },
    "ALMIRANTE BROWN": {
      "1845": true,
      "1848": true,
      "1850": true
    },
    "ARTURO SEGUI": {
      "1985": true
    },
    "AVELLANEDA": {
      "1868": true,
      "1871": true,
      "1873": true
    },
    "BANFIELD": {
      "1821": true
    },
    "BARRIO CHURRUCA": {
      "1691": true
    },
    "BARRIO EL JAGUEL": {
      "1805": true,
      "2707": true
    },
    "BARRIO LA TABLADA": {
      "1751": true
    },
    "BARRIO LOS TRONCOS DEL TALAR": {
      "1608": true
    },
    "BARRIO SAN JOSE (PDO. LOMAS DE ZAMORA)": {
      "1835": true
    },
    "BARRIO SANTA CLARA": {
      "1781": true
    },
    "BARRIO VILLA MARIA DE LOS REMEDIOS DE ESCALADA": {
      "1657": true
    },
    "BECCAR": {
      "1643": true
    },
    "BELEN DE ESCOBAR": {
      "1626": true,
      "1960": true
    },
    "BENAVIDEZ": {
      "1621": true
    },
    "BERAZATEGUI": {
      "1837": true,
      "1860": true,
      "1884": true,
      "1890": true,
      "1893": true
    },
    "BERISSO": {
      "1914": true,
      "1923": true,
      "1924": true
    },
    "Bernal": {
      "1476": true
    },
    "BOULOGNE SUR MER": {
      "1609": true
    },
    "Burzaco": {
      "1490": true
    },
    "CAMPANA": {
      "2804": true,
      "2805": true
    },
    "CARAPACHAY": {
      "1606": true
    },
    "CARLOS SPEGAZZINI": {
      "1812": true,
      "1813": true
    },
    "CASTELAR": {
      "1710": true,
      "1712": true
    },
    "CIUDAD EVITA": {
      "1778": true
    },
    "CIUDADELA": {
      "1701": true
    },
    "CLAYPOLE": {
      "1849": true
    },
    "Claypole": {
      "1486": true
    },
    "COLONIA LOS CHIVATOS": {
      "1802": true
    },
    "CORONEL BRANDSEN": {
      "1980": true,
      "1983": true,
      "1986": true
    },
    "Cuartel V": {
      "1740": true
    },
    "Del Viso": {
      "1469": true
    },
    "DOMINGO FAUSTINO SARMIENTO": {
      "1707": true
    },
    "DON BOSCO": {
      "1876": true,
      "1877": true
    },
    "EL PALOMAR": {
      "1684": true,
      "1685": true
    },
    "EL TALAR": {
      "1618": true
    },
    "EMPALME SAN VICENTE": {
      "1864": true
    },
    "ENSENADA": {
      "1925": true,
      "1926": true,
      "1927": true,
      "1929": true,
      "1931": true
    },
    "ESCALADA": {
      "2801": true
    },
    "ESCOBAR": {
      "1625": true,
      "1628": true
    },
    "ESCUELA SUBOFICIALES SARGENTO CABRAL (APEADERO FCGU)": {
      "1659": true
    },
    "EXALTACION DE LA CRUZ": {
      "1918": true,
      "2763": true,
      "2764": true,
      "2812": true
    },
    "EZEIZA": {
      "1775": true,
      "1801": true,
      "1803": true,
      "1807": true
    },
    "EZPELETA": {
      "1882": true
    },
    "FIORITO": {
      "1831": true
    },
    "FLORENCIO VARELA": {
      "1818": true,
      "1853": true,
      "1859": true,
      "1863": true,
      "1887": true
    },
    "FRANCISCO ALVAREZ": {
      "1745": true
    },
    "GENERAL LAS HERAS": {
      "1733": true
    },
    "GENERAL RODRIGUEZ": {
      "1717": true,
      "1747": true,
      "1749": true,
      "1750": true
    },
    "GERLI (PARTIDO AVELLANEDA)": {
      "1869": true
    },
    "GONZALEZ CATAN": {
      "1758": true
    },
    "González Catán": {
      "1779": true
    },
    "GRAND BOURG": {
      "1660": true
    },
    "GUERNICA": {
      "1862": true
    },
    "HURLINGHAM": {
      "1681": true,
      "1689": true
    },
    "IGNACIO CORREAS": {
      "1909": true
    },
    "INGENIERO ALLAN": {
      "1891": true
    },
    "Ingeniero Maschwitz": {
      "1470": true
    },
    "Isidro Casanova": {
      "1794": true
    },
    "ISLA MARTIN GARCIA": {
      "1601": true
    },
    "ITUZAINGO": {
      "1713": true,
      "1714": true,
      "1715": true
    },
    "JOSE C. PAZ": {
      "1690": true
    },
    "JOSE MARMOL": {
      "1844": true,
      "1846": true
    },
    "KILOMETRO 30": {
      "1612": true
    },
    "KILOMETRO 38 (PDO. GRAL. SARMIENTO)": {
      "1615": true
    },
    "LA CHOZA": {
      "1737": true
    },
    "LA LUCILA": {
      "1637": true
    },
    "LA MATANZA": {
      "1756": true,
      "1769": true,
      "1780": true,
      "1789": true
    },
    "LA PALA": {
      "1902": true
    },
    "LA PLATA": {
      "1898": true,
      "1901": true,
      "1904": true,
      "1908": true,
      "1910": true,
      "1912": true,
      "1916": true,
      "1920": true
    },
    "LA REJA": {
      "1738": true
    },
    "LA SALADA": {
      "1774": true
    },
    "LA TABLADA": {
      "1766": true
    },
    "LANUS": {
      "1800": true,
      "1820": true,
      "1823": true
    },
    "LIMA": {
      "2806": true
    },
    "LOMAS DE ZAMORA": {
      "1827": true,
      "1828": true,
      "1833": true
    },
    "LOMAS DEL MIRADOR": {
      "1752": true
    },
    "LONGCHAMPS": {
      "1854": true
    },
    "Longchamps": {
      "1810": true
    },
    "LOS CARDALES": {
      "2714": true,
      "2814": true
    },
    "LOS EUCALIPTOS": {
      "1895": true
    },
    "LUIS GUILLON": {
      "1777": true
    },
    "LUJAN": {
      "6608": true,
      "6700": true,
      "6701": true,
      "6702": true,
      "6703": true,
      "6706": true,
      "6708": true,
      "6709": true,
      "6712": true
    },
    "MALVINAS ARGENTINAS": {
      "1616": true
    },
    "MANUEL B. GONNET": {
      "1897": true
    },
    "MAQUINISTA FRANCISCO SAVIO": {
      "1620": true
    },
    "MARCOS PAZ": {
      "1783": true,
      "1784": true,
      "1787": true,
      "1788": true,
      "1790": true,
      "1791": true,
      "1793": true
    },
    "MARIANO J. HAEDO": {
      "1706": true
    },
    "MARTIN CORONADO": {
      "1683": true
    },
    "MARTINEZ": {
      "1640": true
    },
    "MAXIMO PAZ": {
      "1809": true,
      "1814": true
    },
    "MERLO": {
      "1721": true,
      "1724": true
    },
    "MINISTRO RIVADAVIA": {
      "1852": true
    },
    "MONTE CHINGOLO": {
      "1825": true
    },
    "MONTE GRANDE": {
      "1841": true,
      "1842": true,
      "1851": true
    },
    "MORENO": {
      "1743": true
    },
    "MORON": {
      "1482": true,
      "1708": true
    },
    "MUÃIZ": {
      "1662": true
    },
    "MUNRO": {
      "1605": true
    },
    "NORDELTA": {
      "1670": true,
      "1671": true
    },
    "OLIDEN": {
      "1981": true
    },
    "OLIVOS": {
      "1636": true
    },
    "PARADA KILOMETRO 76": {
      "1739": true
    },
    "PEREYRA (PDO. BERAZATEGUI)": {
      "1857": true
    },
    "PILA": {
      "1666": true
    },
    "PILAR": {
      "1516": true,
      "1632": true,
      "1634": true,
      "1639": true
    },
    "PLATANOS": {
      "1861": true
    },
    "POBLET": {
      "1905": true
    },
    "PUEBLO NUEVO (GRAL. RODRIGUEZ-PDO. GRAL. RODRIGUEZ)": {
      "1748": true
    },
    "PUENTE SAAVEDRA": {
      "1602": true
    },
    "PUNTA DE CANAL (APEADERO FCGM)": {
      "1623": true
    },
    "QUILMES": {
      "1840": true,
      "1855": true,
      "1883": true,
      "1892": true
    },
    "QUILMES OESTE": {
      "1879": true
    },
    "RAFAEL CASTILLO": {
      "1755": true
    },
    "RAMOS MEJIA": {
      "1704": true
    },
    "RECREO VENECIA": {
      "1896": true
    },
    "RINCON DE MILBERG": {
      "1624": true
    },
    "RIO PARANA GUAZU": {
      "1647": true
    },
    "RUTA 200 KILOMETRO 38": {
      "1723": true
    },
    "RUTA 26 MAQUINISTA FRANCISCO SAVIO": {
      "1619": true
    },
    "SAN ANTONIO DE PADUA": {
      "1718": true
    },
    "SAN FRANCISCO SOLANO": {
      "1843": true,
      "1881": true
    },
    "SAN ISIDRO": {
      "1642": true
    },
    "SAN JUSTO": {
      "1785": true
    },
    "SAN MARTIN": {
      "1654": true,
      "1656": true
    },
    "San Martín": {
      "1500": true
    },
    "SAN MIGUEL": {
      "1663": true
    },
    "SAN PONCIANO": {
      "1903": true
    },
    "SAN VICENTE": {
      "1865": true,
      "1866": true,
      "1984": true
    },
    "SANTA ROSA": {
      "1867": true
    },
    "SARANDI": {
      "1872": true
    },
    "SPERATTI": {
      "1741": true
    },
    "TAPIALES": {
      "1770": true,
      "1792": true
    },
    "Temperley": {
      "1485": true
    },
    "TENIENTE GRAL. RICCHIERI": {
      "1661": true
    },
    "TESEI": {
      "1688": true
    },
    "TIGRE": {
      "1610": true,
      "1622": true
    },
    "TOLOSA": {
      "1900": true,
      "1906": true
    },
    "TORO": {
      "1635": true
    },
    "TORTUGUITAS": {
      "1667": true
    },
    "TRES DE FEBRERO": {
      "1658": true,
      "1687": true,
      "1692": true,
      "1705": true
    },
    "TRISTAN SUAREZ": {
      "1806": true
    },
    "TRUJUI": {
      "1664": true,
      "1736": true
    },
    "URIBELARREA": {
      "1815": true
    },
    "VICEALMIRANTE E. MONTES": {
      "1611": true
    },
    "VICENTE CASARES": {
      "1808": true
    },
    "VICENTE LOPEZ": {
      "1604": true,
      "1638": true,
      "1652": true
    },
    "VICTORIA": {
      "1644": true
    },
    "VILLA ADELINA": {
      "1607": true
    },
    "VILLA ADRIANA": {
      "1816": true
    },
    "VILLA ALBERTINA": {
      "1829": true
    },
    "VILLA ASTOLFI": {
      "1633": true
    },
    "VILLA BALLESTER": {
      "1653": true
    },
    "Villa Ballester": {
      "1693": true
    },
    "VILLA BARRIO ALTUBE": {
      "1665": true
    },
    "VILLA BOSCH": {
      "1682": true
    },
    "VILLA CELINA": {
      "1762": true,
      "1767": true,
      "1772": true
    },
    "VILLA DE MAYO": {
      "1614": true
    },
    "VILLA DEL CARMEN (DEL VISO-PDO. GRAL. SARMIENTO)": {
      "1669": true
    },
    "VILLA ELISA": {
      "1894": true
    },
    "VILLA ESCOBAR": {
      "1746": true
    },
    "VILLA ESPAÃA": {
      "1880": true
    },
    "VILLA GARIBALDI": {
      "1907": true
    },
    "VILLA GIAMBRUNO": {
      "1886": true
    },
    "VILLA GRAL. ZAPIOLA": {
      "1742": true
    },
    "VILLA GUILLERMINA": {
      "1804": true
    },
    "VILLA HENZ": {
      "1836": true
    },
    "VILLA HUDSON": {
      "1889": true
    },
    "VILLA INDUSTRIALES": {
      "1824": true
    },
    "VILLA JARDIN": {
      "1822": true
    },
    "VILLA JOSE INGENIEROS": {
      "1702": true,
      "1703": true
    },
    "VILLA LA ÃATA": {
      "1648": true
    },
    "VILLA LAGO DEL BOSQUE": {
      "1722": true
    },
    "VILLA LANZONI": {
      "1655": true
    },
    "VILLA LAS TUNAS": {
      "1617": true
    },
    "VILLA LAURA (RAFAEL CALZADA-PDO. ALMTE. BROWN)": {
      "1847": true
    },
    "VILLA LUZURIAGA": {
      "1753": true,
      "1754": true
    },
    "VILLA LYNCH (PDO. GRAL. SAN MARTIN)": {
      "1672": true
    },
    "VILLA MADERO": {
      "1768": true
    },
    "VILLA MAGDALENA": {
      "1716": true
    },
    "VILLA MAIPU": {
      "1650": true
    },
    "VILLA MARIA (QUILMES-PDO. QUILMES)": {
      "1878": true
    },
    "VILLA MARTELLI": {
      "1603": true
    },
    "VILLA MONSEGUR": {
      "1744": true
    },
    "VILLA NUÃEZ": {
      "1874": true
    },
    "VILLA NUMANCIA": {
      "1858": true
    },
    "VILLA PARIS": {
      "1856": true
    },
    "VILLA PARISH ROBERTSON": {
      "1838": true
    },
    "VILLA PARQUE": {
      "1678": true
    },
    "VILLA POMPEO": {
      "1826": true
    },
    "VILLA PORVENIR": {
      "1870": true
    },
    "VILLA RAFFO": {
      "1675": true
    },
    "VILLA REAL": {
      "1885": true
    },
    "VILLA RITA": {
      "1832": true
    },
    "VILLA ROSA": {
      "1630": true,
      "1631": true
    },
    "VILLA SAENZ PEÃA": {
      "1674": true
    },
    "VILLA SAN ALBERTO (ISIDRO CASANOVA-PDO. LA MATANZA": {
      "1765": true
    },
    "VILLA SANTA JULIA": {
      "1761": true
    },
    "VILLA SCASSO": {
      "1759": true
    },
    "VILLA TALLERES ALIANZA": {
      "1676": true
    },
    "VILLA TRANSRADIO": {
      "1776": true
    },
    "VILLA TURDERA": {
      "1834": true
    },
    "VILLA UNION": {
      "1757": true
    },
    "VILLA URBANA": {
      "1773": true
    },
    "VILLA VATTEONE": {
      "1888": true
    },
    "VILLA VERDE": {
      "1629": true
    },
    "VILLA ZAGALA": {
      "1651": true
    },
    "VILLARS": {
      "1731": true
    },
    "VIRREY DEL PINO": {
      "1763": true,
      "1764": true
    },
    "VIRREYES": {
      "1645": true,
      "1646": true
    },
    "WILDE ESTE": {
      "1875": true
    },
    "WILLIAMS C. MORRIS (PARADA FCGSM)": {
      "1686": true
    },
    "YAPEYU": {
      "1613": true
    },
    "ZAMUDIO (APEADERO FCDFS)": {
      "1727": true
    },
    "ZANJA TAMAGNI": {
      "1649": true
    },
    "ZARATE": {
      "2800": true,
      "2802": true,
      "2807": true,
      "2808": true
    },
    "ZELAYA": {
      "1627": true
    }
  },
  "CIUDAD AUTONOMA DE BUENOS AIRES": {
    "ALMAGRO": {
      "1179": true,
      "1180": true,
      "1181": true,
      "1182": true,
      "1183": true,
      "1184": true,
      "1185": true,
      "1186": true,
      "1187": true,
      "1188": true,
      "1189": true,
      "1190": true,
      "1191": true,
      "1192": true,
      "1193": true,
      "1194": true,
      "1195": true,
      "1196": true,
      "1197": true,
      "1198": true,
      "1199": true
    },
    "BALVANERA": {
      "1100": true,
      "1101": true,
      "1102": true,
      "1103": true,
      "1104": true,
      "1105": true,
      "1106": true,
      "1107": true,
      "1108": true,
      "1109": true,
      "1110": true,
      "1111": true,
      "1112": true,
      "1113": true,
      "1114": true,
      "1115": true,
      "1116": true,
      "1117": true,
      "1118": true,
      "1119": true,
      "1120": true,
      "1121": true,
      "1122": true,
      "1123": true,
      "1124": true,
      "1125": true,
      "1126": true,
      "1127": true,
      "1128": true,
      "1129": true,
      "1130": true,
      "1131": true,
      "1132": true,
      "1133": true,
      "1134": true,
      "1135": true,
      "1136": true,
      "1137": true,
      "1138": true,
      "1139": true,
      "1140": true,
      "1141": true,
      "1142": true,
      "1143": true,
      "1144": true,
      "1145": true,
      "1146": true,
      "1147": true,
      "1148": true,
      "1149": true,
      "1150": true,
      "1151": true,
      "1152": true,
      "1153": true,
      "1154": true,
      "1155": true,
      "1156": true,
      "1157": true,
      "1158": true,
      "1159": true,
      "1160": true,
      "1161": true,
      "1162": true,
      "1163": true,
      "1164": true,
      "1165": true,
      "1166": true,
      "1167": true,
      "1168": true,
      "1169": true,
      "1170": true,
      "1171": true,
      "1172": true,
      "1173": true,
      "1174": true,
      "1175": true,
      "1176": true,
      "1177": true,
      "1178": true
    },
    "BELGRANO": {
      "1427": true,
      "1428": true,
      "1429": true
    },
    "CABA": {
      "1300": true,
      "1301": true,
      "1302": true,
      "1303": true,
      "1304": true,
      "1305": true,
      "1306": true,
      "1307": true,
      "1308": true,
      "1309": true,
      "1310": true,
      "1311": true,
      "1312": true,
      "1313": true,
      "1314": true,
      "1315": true,
      "1316": true,
      "1317": true,
      "1318": true,
      "1319": true,
      "1320": true,
      "1321": true,
      "1322": true,
      "1323": true,
      "1324": true,
      "1325": true,
      "1326": true,
      "1327": true,
      "1328": true,
      "1329": true,
      "1330": true,
      "1331": true,
      "1332": true,
      "1333": true,
      "1334": true,
      "1335": true,
      "1336": true,
      "1337": true,
      "1338": true,
      "1339": true,
      "1340": true,
      "1341": true,
      "1342": true,
      "1343": true,
      "1344": true,
      "1345": true,
      "1346": true,
      "1347": true,
      "1348": true,
      "1349": true,
      "1350": true,
      "1351": true,
      "1352": true,
      "1353": true,
      "1354": true,
      "1355": true,
      "1356": true,
      "1357": true,
      "1358": true,
      "1359": true,
      "1360": true,
      "1361": true,
      "1362": true,
      "1363": true,
      "1364": true,
      "1365": true,
      "1366": true,
      "1367": true,
      "1368": true,
      "1369": true,
      "1370": true,
      "1371": true,
      "1372": true,
      "1373": true,
      "1374": true,
      "1375": true,
      "1376": true,
      "1377": true,
      "1378": true,
      "1379": true,
      "1380": true,
      "1381": true,
      "1382": true,
      "1383": true,
      "1384": true,
      "1385": true,
      "1386": true,
      "1387": true,
      "1388": true,
      "1389": true,
      "1390": true,
      "1391": true,
      "1392": true,
      "1393": true,
      "1394": true,
      "1395": true,
      "1396": true,
      "1397": true,
      "1398": true,
      "1399": true,
      "1400": true,
      "1401": true,
      "1402": true,
      "1453": true,
      "1599": true
    },
    "CABALLITO": {
      "1250": true,
      "1251": true,
      "1252": true,
      "1253": true,
      "1254": true,
      "1255": true,
      "1256": true,
      "1257": true,
      "1258": true,
      "1259": true,
      "1260": true,
      "1261": true,
      "1262": true,
      "1263": true,
      "1264": true,
      "1265": true,
      "1266": true,
      "1267": true,
      "1268": true,
      "1269": true,
      "1405": true,
      "1407": true,
      "1408": true,
      "1409": true,
      "1410": true,
      "1411": true,
      "1412": true,
      "1413": true
    },
    "CIUDAD AUTONOMA DE BUENOS AIRES": {
      "1000": true,
      "1001": true,
      "1297": true,
      "1299": true,
      "1403": true,
      "1404": true,
      "1406": true,
      "1415": true,
      "1418": true,
      "1419": true,
      "1425": true,
      "1430": true,
      "1438": true,
      "1441": true,
      "1442": true,
      "1443": true,
      "1444": true,
      "1445": true,
      "1446": true,
      "1447": true,
      "1448": true,
      "1449": true,
      "1450": true,
      "1451": true,
      "1452": true,
      "1454": true,
      "1455": true,
      "1456": true,
      "1458": true,
      "1459": true,
      "1460": true,
      "1461": true,
      "1462": true,
      "1463": true,
      "1464": true,
      "1465": true,
      "1472": true,
      "1479": true,
      "1480": true,
      "1487": true,
      "1507": true,
      "1524": true,
      "1527": true,
      "1732": true,
      "1782": true,
      "7777": true,
      "9960": true,
      "9975": true,
      "9989": true,
      "9990": true,
      "9991": true
    },
    "COLEGIALES": {
      "1432": true,
      "1433": true,
      "1434": true,
      "1435": true,
      "1436": true
    },
    "FLORES": {
      "1270": true,
      "1271": true,
      "1272": true,
      "1273": true,
      "1274": true,
      "1275": true,
      "1276": true,
      "1277": true,
      "1278": true,
      "1279": true,
      "1280": true,
      "1281": true,
      "1282": true,
      "1283": true,
      "1284": true,
      "1285": true,
      "1286": true,
      "1287": true,
      "1288": true,
      "1289": true,
      "1290": true,
      "1291": true,
      "1292": true,
      "1293": true,
      "1294": true,
      "1295": true,
      "1296": true,
      "1298": true,
      "1437": true,
      "1439": true,
      "1440": true
    },
    "MONSERRAT": {
      "1050": true,
      "1051": true,
      "1052": true,
      "1053": true,
      "1054": true,
      "1055": true,
      "1056": true,
      "1057": true,
      "1058": true,
      "1059": true,
      "1060": true,
      "1061": true,
      "1062": true,
      "1063": true,
      "1064": true,
      "1065": true,
      "1066": true,
      "1067": true,
      "1068": true,
      "1069": true
    },
    "NUÑEZ": {
      "1431": true
    },
    "PALERMO": {
      "1414": true,
      "1416": true,
      "1417": true,
      "1420": true,
      "1421": true,
      "1422": true,
      "1423": true,
      "1424": true
    },
    "PARQUE PATRICIOS": {
      "1225": true,
      "1226": true,
      "1227": true,
      "1228": true,
      "1229": true,
      "1230": true,
      "1231": true,
      "1232": true,
      "1233": true,
      "1234": true,
      "1235": true,
      "1236": true,
      "1237": true,
      "1238": true,
      "1239": true,
      "1240": true,
      "1241": true,
      "1242": true,
      "1243": true,
      "1244": true,
      "1245": true,
      "1246": true,
      "1247": true,
      "1248": true,
      "1249": true
    },
    "RECOLETA": {
      "1426": true
    },
    "RETIRO": {
      "1002": true,
      "1003": true,
      "1004": true,
      "1005": true,
      "1006": true,
      "1007": true,
      "1008": true,
      "1009": true,
      "1010": true,
      "1011": true,
      "1012": true,
      "1013": true,
      "1014": true,
      "1015": true,
      "1016": true,
      "1017": true,
      "1018": true,
      "1019": true
    },
    "SAN CRISTOBAL": {
      "1200": true,
      "1201": true,
      "1202": true,
      "1203": true,
      "1204": true,
      "1205": true,
      "1206": true,
      "1207": true,
      "1208": true,
      "1209": true,
      "1210": true,
      "1211": true,
      "1212": true,
      "1213": true,
      "1214": true,
      "1215": true,
      "1216": true,
      "1217": true,
      "1218": true,
      "1219": true,
      "1220": true,
      "1221": true,
      "1222": true,
      "1223": true,
      "1224": true
    },
    "SAN NICOLAS": {
      "1020": true,
      "1021": true,
      "1022": true,
      "1023": true,
      "1024": true,
      "1025": true,
      "1026": true,
      "1027": true,
      "1028": true,
      "1029": true,
      "1030": true,
      "1031": true,
      "1032": true,
      "1033": true,
      "1034": true,
      "1035": true,
      "1036": true,
      "1037": true,
      "1038": true,
      "1039": true,
      "1040": true,
      "1041": true,
      "1042": true,
      "1043": true,
      "1044": true,
      "1045": true,
      "1046": true,
      "1047": true,
      "1048": true,
      "1049": true
    },
    "SAN TELMO": {
      "1070": true,
      "1071": true,
      "1072": true,
      "1073": true,
      "1074": true,
      "1075": true,
      "1076": true,
      "1077": true,
      "1078": true,
      "1079": true,
      "1080": true,
      "1081": true,
      "1082": true,
      "1083": true,
      "1084": true,
      "1085": true,
      "1086": true,
      "1087": true,
      "1088": true,
      "1089": true,
      "1090": true,
      "1091": true,
      "1092": true,
      "1093": true,
      "1094": true,
      "1095": true,
      "1096": true,
      "1097": true,
      "1098": true,
      "1099": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}